define('views/content/blacklist',['require','typeahead','bloodhound','views/base/list_page_view','views/components/blacklist_user/users','collections/users','text!templates/content/blacklist.html'],function(require){

    require('typeahead');
    require('bloodhound');

    var BaseListPageView = require('views/base/list_page_view');

    var BlacklistUsersView = require('views/components/blacklist_user/users');
    var UsersCollection = require('collections/users');

    var temp = require("text!templates/content/blacklist.html");

    return BaseListPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'user-page',
        titleKey: 'blacklist',
        selectedUser: null,

        setCollection: function () {
            this.collection = new UsersCollection([], {
                parameters: {
                    'is_activated': false
                }
            });
        },

        ui: function() {
            return {
                userField: '.users-typeahead',

                messageTurkish: '#message_turkish',
                messageEnglish: '#message_english',

                blockButton: '#block-button'
            };
        },

        events: {
            'click @ui.blockButton': 'blockButtonClicked'
        },

        onRender: function() {
            this.ListContainer.show(new BlacklistUsersView({
                collection: this.collection
            }));

            var _this = this;

            // Setup typeahed for user field
            var usersTypeahedEngine = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.whitespace,
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                remote: {
                    url: App.Config.apiBase + 'users/typeahead/',
                    replace: function(url, query) {
                        return url + ('?query=' + encodeURIComponent(_this.ui.userField.val()));
                    }
                },
                identify: function(obj) {
                    return obj.id;
                }
            });

            this.ui.userField.typeahead({
                minLength: 3
            }, {
                name: 'users',
                source: usersTypeahedEngine,
                display: 'username'
            });

            // Get selected reseller's id
            this.ui.userField.bind('typeahead:select', function (ev, suggestion) {
                _this.selectedUser = suggestion.id;
            });


            // Set default message texts
            var englishMessage = localStorage.getItem('block_message_english');
            if (englishMessage) {
                this.ui.messageEnglish.val(englishMessage);
            }

            var turkishMessage = localStorage.getItem('block_message_turkish');
            if (turkishMessage) {
                this.ui.messageTurkish.val(turkishMessage);
            }
        },

        blockButtonClicked: function () {
            var _this = this;

            if (this.selectedUser) {
                this.ui.blockButton.addClass('loading');

                var parameters = {};
                var messageLanguage = this.$el.find('[name="message_language"]:checked').val();
                if (messageLanguage) {
                    if (messageLanguage == 'english') {
                        parameters.message = this.ui.messageEnglish.val();

                        // Save message in local storage
                        localStorage.setItem('block_message_english', this.ui.messageEnglish.val());
                    } else if (messageLanguage == 'turkish') {
                        parameters.message = this.ui.messageTurkish.val();

                        // Save message in local storage
                        localStorage.setItem('block_message_turkish', this.ui.messageTurkish.val());
                    }
                }

                $.ajax({
                    url: App.Config.apiBase + 'users/' + this.selectedUser + '/block/',
                    method: 'post',
                    data: parameters,
                    success:function(response) {
                        _this.ui.blockButton.removeClass('loading');
                        _this.collection.fetch();

                        App.utils.showMessage('success', App.polyglot.t('block_success'));
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        _this.ui.blockButton.removeClass('loading');

                        // Show error messages
                        if (xhr.responseJSON.errors) {
                            for (var i=0; i<xhr.responseJSON.errors.length; i++) {
                                App.utils.showMessage('error', xhr.responseJSON.errors[i].message);
                            }
                        }
                    }
                });
            } else {
                App.utils.showMessage('error', App.polyglot.t('no_user_selected'));
            }
        }

    });
});
